import { React, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Grid,
  TextField,
  useTheme,
} from "@material-ui/core";
import axios from "axios";
import * as sweetalert from "sweetalert";
import { tokens } from "../../../styles/theme";
import packageJson from "../../../../package.json";
import { useForm } from "./useForm";
import Controls from "../global/controls/Controls";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export const ForgetPassword = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [forgetpassword, setforgetpassword] = useState({
    mobile_number: "",
  });
  const initialFValues = {
    mobile_number: "",
  };
  const validate = (fieldValues = loginInput) => {
    let temp = { ...errors };
    temp.mobile_number = fieldValues.mobile_number ? "" : "رقم الهاتف مطلوب";
  
    if (fieldValues.mobile_number) {
      if (!/^[0-9]+$/.test(fieldValues.mobile_number)) {
        temp.mobile_number = "يجب أن يكون رقم الموبايل أرقام فقط";
      } else if (fieldValues.mobile_number.length !== 10) {
        temp.mobile_number = "يجب أن يكون رقم الموبايل 10 أرقام";
      }
    }
  
  
  
    setErrors({
      ...temp,
    });
  
    if (fieldValues === loginInput) {
      return Object.values(temp).every((x) => x === "");
    }
  };
  const handeleInput = (e) => {
    e.persist();
    setLogin({
      ...loginInput,
      [e.target.name]: e.target.value,
    });
    // setforgetpassword({ ...forgetpassword, [e.target.name]: e.target.value });
  };
  const forgetSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setLoading(true);
    const data = {
      mobile_number: loginInput.mobile_number,
    };

    axios
      .post(`${BaseUrl}/api/mobile/password/forget`, data, {
        withCredentials: true,
      })
      .then((res) => {
        if (res.data.status === true) {
          setLoading(false);
          sweetalert("A new code has been sent to your mobile.");
          navigate("/reset-password");
        } else if (res.data.status === false) {
          setLoading(false);
          sweetalert("the number is not exist");
        }
      });
  };
  };
  const { loginInput, setLogin, errors, setErrors } = useForm(
    initialFValues,
    true,
    validate
  );
  return (
    <div>
      <form className="form-group" onSubmit={forgetSubmit}>
        <Grid container style={{ minHeight: "100vh" }}>
          <Grid item className="home-item" xs={12} sm={6}>
            <h1 style={{ textAlign: "center" }}>ليرتنا كاش</h1>
            <p>
              {" "}
              صمم هذا التطبيق ليكون أداة مساعدة لمراكز تعبئة الرصيد في سوريا،
              فهو مخصص لتحويل الوحدات و تسديد الفواتير لشبكتي سيرياتل و ام تي ان
              بسهولة بالغة، يقدم إمكانية إدارة موزعين الجملة و مراكز الخدمة في
              مختلف المحافظات و المناطق مع إمكانية حفظ الزبائن في قاعدة البيانات
              و بالتالي يمكن التحويل للعميل من خلال اختيار اسمه وتحديد كمية
              الوحدات فقط، كما أنه يمكن حفظ نسخة من التقارير بأنواعها المختلفة
              ضمن سجل خاص{" "}
            </p>
            <img src="hom.svg" alt="login-img" />
            {/* <div style={{position: "absolute", color: "white",top: 10,left: "50%",transform: "translateX(-50%)",backgroundColor:'black'}}></div> */}
          </Grid>
          <Grid
            container
            item
            alignItems="center"
            direction="column"
            justify="center"
            xs={12}
            sm={6}
            style={{ padding: 10 }}
          >
            <div>
              <h2 className="title-home">هل نسيت كلمة المرور</h2>
              <h3 className="title-home">
                  إدخال رقم الموبايل لإرسال رمز التحقق
              </h3>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
                 <Controls.Input
                label="رقم الهاتف"
                name="mobile_number"
                fullWidth
               
                onChange={handeleInput}
                className="form-control"
                error={errors.mobile_number}
                type="text"
              />
          
      {loading === true ? (
                <>
                  <Controls.Button
                    text=<div class="spinner center">
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                    </div>
                    variant="contained"
                    className="btn-submit resend-code"
                  ></Controls.Button>
                </>
              ) : (
                <>
                  <Controls.Button
                    type="submit"
                    onClick={forgetSubmit}
                    text="إرسال"
                    variant="contained"
                    className="btn-submit"
                  ></Controls.Button>
                </>
              )}
              <div style={{ height: 20 }} />
            </div>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};
